import { Injectable } from '@angular/core';

declare const window: Window & { dataLayer: any[] };

@Injectable({ providedIn: 'root' })
export class AnalyticsService {
    pushEvent(eventName: string, params: { episode_id: number; [key: string]: any }): void {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ event: eventName, ...params });
    }

    setUserId(userId: number | null): void {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ user_id: userId });
    }
}
